import { FormInputMultiline, DatePickerComponent, FormInput } from '../../../component/input/InputStyle';
import GridComponent from '../../../component/grid/GridComponent.component';
import Notification from '../interfaces/Notification';
import { useFormik } from 'formik';
import { FormInterface } from '../../../core/interfaces/form/Form';
import FormLabel from '../../../component/input/FormLabel.component';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { Form } from '../../../component/form/Form';
import FormHeader from './FormHeader.component';
import ButtonLink from '../../../component/buttton/ButtonLink.component';
import { FormatDateHours } from '../../../utils/format/FormatDate';
import { Grid } from '@material-ui/core';

export default function FormComponent({ handleSubmitForm, initialValues, disabled }: FormInterface<Notification>) {

    const { handleSubmit, handleChange, values, setFieldValue } = useFormik<Notification>({
        initialValues: initialValues,
        onSubmit: values => {
            handleSubmitForm(values);
        },
    });

    return (
        <Form onSubmit={handleSubmit}>

            <GridComponent justify="flex-start" alignItems="center" spacing={2} >
                <FormHeader handleChange={handleChange} initialValues={values} setFieldValue={setFieldValue} disabled={disabled} />
                <FormLabel title="Descrição da Falha - Técnica" required={!disabled}>
                    <FormInputMultiline
                        name="faultDescription"
                        value={values.faultDescription}
                        onChange={handleChange}
                        disabled={disabled}
                        renderInput={(props: any) => <FormInput {...props} />}
                        required
                    />
                </FormLabel>
                <FormLabel title="Descrição da Falha - Negócio" required={!disabled}>
                    <FormInputMultiline
                        name="serviceHealthBusiness"
                        value={values.serviceHealthBusiness}
                        onChange={handleChange}
                        disabled={disabled}
                        renderInput={(props: any) => <FormInput {...props} />}
                        required
                    />
                </FormLabel>

                <FormLabel title="Impacto Inicial" required={!disabled}>
                    <FormInputMultiline
                        name="initialImpact"
                        value={values.initialImpact}
                        onChange={handleChange}
                        disabled={disabled}
                        required
                    />
                </FormLabel>
                <FormLabel title="UUNN Afetadas" required={!disabled}>
                    <FormInputMultiline
                        name="UUNNStoresAffected"
                        value={values.UUNNStoresAffected}
                        onChange={handleChange}
                        disabled={disabled}
                        required
                    />
                </FormLabel>
                <FormLabel title="Data/Hora identificada" sm={4} required={!disabled}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePickerComponent
                            value={values.timeFaulIdentified || null}
                            onChange={(date: Date | string) => setFieldValue('timeFaulIdentified', date)}
                            disabled={disabled}
                            renderInput={(props: any) => <FormInput {...props} />}
                        />
                    </LocalizationProvider>
                </FormLabel>
                {values.created_at && <FormLabel title="Data/Hora Notificação" sm={4}>
                    <FormInput value={FormatDateHours(values.created_at)} disabled />
                </FormLabel>
                }
                {values.loginCreated && <FormLabel title="Criado Por" sm={4}>
                    <FormInput value={values.loginCreated} disabled />
                </FormLabel>
                }
            </GridComponent>

            <GridComponent justify="flex-start" alignItems="flex-start" spacing={2} margin="20px 0px 30px 10px">
                <Grid item>
                    <ButtonLink link={`/notificacao/follow-up/${initialValues.id}`} title="Follow-up" size='medium' />
                </Grid>
                <Grid item>
                    <ButtonLink link={`/notificacao/fechar-notificacao/${initialValues.id}`} title="Encerrar" variant='outlined' size='medium' />
                </Grid>
            </GridComponent>
        </Form>
    )
}